// Validação partilhada de ficheiros de avatar (foto de perfil).
// Raster only — SVG excluído (XSS), GIF excluído (animação).
const TIPOS_PERMITIDOS = ['image/png', 'image/jpeg', 'image/webp'];
const TAMANHO_MAX = 2 * 1024 * 1024; // 2MB

export type ResultadoAvatar = 'ok' | 'tipo' | 'tamanho';

export function validarFicheiroAvatar(file: File): ResultadoAvatar {
  if (!TIPOS_PERMITIDOS.includes(file.type)) return 'tipo';
  if (file.size > TAMANHO_MAX) return 'tamanho';
  return 'ok';
}
